import { render } from "./ApartmentPage.vue?vue&type=template&id=830ff8de"
import script from "./ApartmentPage.vue?vue&type=script&lang=js"
export * from "./ApartmentPage.vue?vue&type=script&lang=js"

import "./ApartmentPage.vue?vue&type=style&index=0&id=830ff8de&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__